import { useEffect, useState } from "react"
import { TableDataV2 } from "@/components/common/Tablev2"
import { Protected } from "@/components/layout/Protected"
import { Autocomplete, Box, Button, Container, Grid, TextField, Typography } from "@mui/material"
import { Loading } from "@/components/common/Loading"
import { CountryService } from "@/service/services/Country.service"
import { Props } from "./Departament.type"
import { ModalCountryDepartament } from "@/components/Modal/ModalCountryDepartament/ModalCountryDepartament"
import { ModalCountryDepartamentDelete } from "@/components/Modal/ModalCountryDepartamentDelete/ModalCountryDepartamentDelete"
import ___PHRASE from "@/service/translate/translateService"

export const DepartamentView: React.FC<Props> = (props:any): JSX.Element => {

    const [loading, setLoading] = useState<boolean>(false);
    const [departaments, setDepartaments] = useState<any>([]);
    const [showDepartamentModal, setShowDepartamentModal] = useState<boolean>(false);
    const [showDepartamentDeleteModal, setShowDepartamentDeleteModal] = useState<boolean>(false);
    const [departamentSelected, setDepartamentSelected] = useState<any>('');
    const [actionSelected, setActionSelected] = useState<any>('');

    const [countries, setCountries] = useState<any>([]);
    const [countrySelected, setCountrySelected] = useState<any>('');
    

    useEffect(() => {
        getCountries();
    }, []);

    useEffect(() => {
        if(countrySelected) getDepartments(countrySelected.id);
    }, [countrySelected]);

    const getCountries = async () => {
        setLoading(true);
        await CountryService.getCountries().then((data) => {
            setCountries(data.data || []);
            setCountrySelected(data.data[0] || '');
           setLoading(false);
        });
    }

    const getDepartments = async (idCountry) => {
        setLoading(true);
        await CountryService.getDepartments(idCountry).then((data) => {
            setDepartaments(data.data || [])
           setLoading(false);
        });
    }

    function RecuperarData(value){
        setDepartamentSelected(value)
        console.log(value)
    }

    const searchData = async (value) => {
        await CountryService.getDepartments(countrySelected.id, value).then((data) => {
            setDepartaments(data.data || [])
        });
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container>
                <Grid item xs={12} container direction={'row'} justifyContent='space-between' alignItems={'center'} sx={{marginLeft:'25px'}}>
                    <Typography variant='h6' component='h1' gutterBottom className="tittle" sx={{ mt: 1 , fontWeight:600}}>{___PHRASE("filtrosDeBusqueda")}</Typography>
                    <Grid item container direction={'row'} xs={10} spacing={2} >
                        <Grid item xs={12} md={4} mt={2}>
                            <Autocomplete
                            id="disable-portal"
                            disablePortal
                            value={countrySelected}
                            options={countries || []}
                            getOptionLabel={(option) => option.name || ""}
                            fullWidth
                            renderInput={(params) => <TextField {...params} label={___PHRASE("filtrarPorPais")} />}
                            onChange={(e, newValue) => {
                                if (newValue) {
                                    setCountrySelected(newValue);
                                    getDepartments(newValue.id);
                                }
                            }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
                <TableDataV2
                    title={___PHRASE("regiones")}
                    data={departaments || []}
                    header={[
                        { name: 'code', label: ___PHRASE("codigo"), filter: false, Chip: false },
                        { name: 'name', label: ___PHRASE("nombre"), filter: false, Chip: false },
                    ]}
                    actionSelect={setActionSelected}
                    setModalSave={setShowDepartamentModal}
                    setModalDelete={setShowDepartamentDeleteModal}
                    status_action
                    textSearch={___PHRASE("buscarRegion")}
                    searchData={searchData}
                    RecuperarData={RecuperarData}
                />
            </Container>

            { 
                showDepartamentModal && (
                    <ModalCountryDepartament
                        open={showDepartamentModal}
                        closeModal={()=>{setShowDepartamentModal(false); setDepartamentSelected('')}}
                        actionSelected={actionSelected}
                        onListDepartament={getDepartments}
                        departament={departamentSelected}
                        clearState={()=>{setDepartamentSelected('')}}
                        countrySelected={countrySelected}
                    />
                )
            }
            {
                actionSelected === 'delete' && (
                    <ModalCountryDepartamentDelete
                        open={showDepartamentDeleteModal}
                        closeModal={()=>{setShowDepartamentDeleteModal(false);setDepartamentSelected('')}}
                        actionSelected={actionSelected}
                        onListDepartament={getDepartments}
                        departament={departamentSelected}
                        clearState={()=>{setDepartamentSelected('')}}
                        countrySelected={countrySelected}
                    />
                )
            }
        </Protected>
    )
}